// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"556":"e3381dce","614":"d5a44db1","652":"1cd8ac3f","749":"9c0a4e14","951":"59e3159f"}[chunkId] + ".chunk.css";
};